module.exports = __webpack_public_path__ + "img/loading.abba0c0f.gif";